import React from 'react';
import { cn } from './cn';

/**
 * Skeleton — shimmer-on placeholder. Match the shape of the real content
 * (line width, height, rounded-*) rather than dropping in a generic box.
 */
export function Skeleton({ className, ...rest }) {
  return (
    <div
      aria-hidden
      className={cn(
        'rounded-md bg-gradient-to-r from-ink-100 via-ink-200 to-ink-100 dark:from-ink-800 dark:via-ink-700 dark:to-ink-800',
        'bg-[length:800px_100%] animate-shimmer',
        className,
      )}
      {...rest}
    />
  );
}

export function SkeletonText({ lines = 3, className }) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={cn('h-3', i === lines - 1 ? 'w-2/3' : 'w-full')}
        />
      ))}
    </div>
  );
}

/**
 * SkeletonTable — drop-in for list pages while data loads.
 *   <SkeletonTable rows={8} columns={6} />
 */
export function SkeletonTable({ rows = 6, columns = 5, className }) {
  return (
    <div className={cn('rounded-lg border border-line bg-surface shadow-e1', className)}>
      <div className="grid border-b border-line bg-surface-muted px-4 py-3" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`, gap: '1rem' }}>
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={i} className="h-3 w-16" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div
          key={r}
          className="grid border-b border-line last:border-0 px-4 py-3"
          style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`, gap: '1rem' }}
        >
          {Array.from({ length: columns }).map((_, c) => (
            <Skeleton key={c} className={cn('h-3', c === 0 ? 'w-3/4' : 'w-1/2')} />
          ))}
        </div>
      ))}
    </div>
  );
}

export default Skeleton;
